import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import { fadeUp, stagger } from "@/lib/animations";

type PageShellProps = {
  title: string;
  eyebrow?: string;
  children: ReactNode;
};

export default function PageShell({ title, eyebrow, children }: PageShellProps) {
  return (
    <section className="min-h-[70dvh] px-6 py-28" style={{ backgroundColor: colors.cream }}>
      <motion.div
        className="mx-auto max-w-3xl"
        initial="hidden"
        animate="visible"
        variants={stagger}
      >
        {eyebrow && (
          <motion.p
            variants={fadeUp}
            custom={0}
            className="mb-3 text-xs uppercase"
            style={{
              fontFamily: fonts.body,
              fontWeight: 800,
              letterSpacing: "0.12em",
              color: colors.berryRose,
            }}
          >
            {eyebrow}
          </motion.p>
        )}
        <motion.h1
          variants={fadeUp}
          custom={1}
          className="mb-6 text-4xl sm:text-5xl"
          style={{ fontFamily: fonts.logo, color: colors.navy, fontWeight: 400 }}
        >
          {title}
        </motion.h1>
        <motion.div variants={fadeUp} custom={2}>
          {children}
        </motion.div>
      </motion.div>
    </section>
  );
}
